import { memo, useCallback, useMemo, useState } from 'react';
import { Spacings } from '@picsart/cascade';
import { View } from '@picsart/view';
import { ExpandStates } from '@picsart/editorlayout';

import { VIDEO } from 'configs/constants';
import { DataActionTypes } from 'pages/Batch/sections/Context';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import RatioCards, { PartialCard } from 'components/common/RatioCards';
import ResizeByPadding from 'pages/Batch/sections/Sidebar/ResizeTool/ResizeByPadding';
import analytics, { SubToolNames } from 'pages/Batch/utils/analytics';
import { BATCH_TOOLS } from 'pages/Batch/configs';
import useMemoSelector from 'hooks/useMemoSelector';
import { getRatioCards } from 'store/selectors/general';

const ResizeBySocial = ({ isEnabledResizeByPadding = true }: { isEnabledResizeByPadding?: boolean }) => {
  const { dispatchData, resizeParams, isWeb, expandedState } = useBatchData();
  const ratioCards = useMemoSelector(getRatioCards);

  const [selectedSocial, setSelectedSocial] = useState<PartialCard | null>(ratioCards[0] ?? null);

  const filteredItems = useMemo<PartialCard[]>(() => ratioCards.filter(el => el.ratio_type !== VIDEO && !el.name.toLowerCase().includes(VIDEO)).map(el => ({
    id: el.id,
    name: el.name,
    preview_url: el.preview_url,
    type: 0,
    size: {
      width: Number(el.size.width),
      height: Number(el.size.height),
    },
  })), [ratioCards]);

  const handleActivePadding = useCallback((isActive: boolean) => {
    if (!selectedSocial) {
      return;
    }
    dispatchData({
      type: DataActionTypes.SET_RESIZE_PARAMS,
      params: {
        ...resizeParams,
        width: selectedSocial.size.width,
        height: selectedSocial.size.height,
        usePadding: isActive,
      },
    });
  }, [selectedSocial, dispatchData, resizeParams]);

  const handleSelectSocial = useCallback(item => {
    setSelectedSocial(item);
    const isOriginalSelected = !item.size.width && !item.size.height;
    dispatchData({
      type: DataActionTypes.SET_RESIZE_PARAMS,
      params: {
        ...resizeParams,
        width: item.size.width,
        height: item.size.height,
        isOriginal: isOriginalSelected,
      },
    });
    analytics.utils().setSubTool(BATCH_TOOLS.resize, {
      name: SubToolNames.socialSize,
      value: item.name,
    });
  }, [resizeParams, dispatchData]);

  return (
    <View flexDirection="column" marginBlockStart={Spacings.s12}>
      <RatioCards onCardSelect={handleSelectSocial} selectedCard={selectedSocial} cards={filteredItems} showAsCarousel={!isWeb && expandedState !== ExpandStates.Full} />
      {(isEnabledResizeByPadding && selectedSocial) && <ResizeByPadding onActivePadding={handleActivePadding} />}
    </View>
  );
};

export default memo(ResizeBySocial);
